import { Mention as TiptapMention } from '@tiptap/extension-mention'

import { useKnowledgeBaseSuggestions } from '@/extensions/Mention/knowledge-base/hooks'
import { getKnowledgeBaseSuggestionParams } from '@/extensions/Mention/lib'
import type {
  MentionArgs,
  MentionExtensionOptions,
  Suggestions,
} from '@/extensions/Mention/types'
import { useUserSuggestions } from '@/extensions/Mention/user/hooks'

const useSuggestions = (options?: MentionArgs) => {
  const { suggestion, onSelect } = options ?? {}

  const userSuggestions = useUserSuggestions({ onSelect })

  const knowledgeBaseSuggestions = useKnowledgeBaseSuggestions({
    params: getKnowledgeBaseSuggestionParams(suggestion),
    onSelect,
  })

  if (suggestion?.type === 'knowledge-base') {
    return knowledgeBaseSuggestions
  }

  return userSuggestions
}

const Mention = TiptapMention.extend<MentionExtensionOptions>({
  addAttributes() {
    return {
      ...this.parent?.(),
      type: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-mention-type'),
        renderHTML: (attributes) => {
          if (!attributes.type) {
            return {}
          }
          return {
            'data-mention-type': attributes.type,
          }
        },
      },
    }
  },
})

export {
  Mention,
  useSuggestions,
  type MentionExtensionOptions,
  type MentionArgs,
  type Suggestions,
}
